ike-demo-alert{
  .demo_alert{
    /* Auto layout */

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 20px 20px;
    z-index: 99999;
    background: $main-color;
  }

  .sticky {
    position: fixed;
    top: 0;
    width: 100%
  }

  i {
    color: white;
  }

  span {
    color: white;
    font-size: 14px;
    font-weight: 400;
  }
}
